(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-panel-tipsen/assets/javascripts/sport-events-wrapper.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-panel-tipsen/assets/javascripts/sport-events-wrapper.js');
"use strict";


const {
  useSelector
} = ReactRedux;
const {
  SportEvent
} = svs.components.tipsen.drawPanelTipsen;
const {
  useMemoizedSelector
} = svs.components.lbUtils.hooks;
const {
  makeSelectBetEventsFromDraw
} = svs.components.tipsen.selectors;
const {
  ForEach
} = svs.components.lbUtils.reactConditionals;
const SportEventsWrapper = _ref => {
  let {
    productDrawId,
    limit = 1
  } = _ref;
  const selectBetEventsFromDraw = useMemoizedSelector(makeSelectBetEventsFromDraw, productDrawId);
  const sportEvents = useSelector(selectBetEventsFromDraw);
  const cappedLimit = limit < sportEvents.length ? limit : sportEvents.length;
  const additionalEventsCount = sportEvents.length > 0 ? sportEvents.length - cappedLimit : 0;
  const getShouldShowAdditionalCount = index => additionalEventsCount > 0 && index === cappedLimit - 1;
  const cappedEvents = sportEvents.slice(0, cappedLimit);
  return React.createElement("div", {
    className: "sport-events-wrapper"
  }, React.createElement(ForEach, {
    array: cappedEvents,
    render: (sportEvent, index) => {
      const key = "".concat(sportEvent.matchId, "-").concat(sportEvent.participantType);
      const shouldShowAdditionalCount = getShouldShowAdditionalCount(index);
      return React.createElement(SportEvent, {
        additionalEventsCount: shouldShowAdditionalCount ? additionalEventsCount : undefined,
        key: key,
        sportEventData: sportEvent
      });
    }
  }));
};
setGlobal('svs.components.tipsen.drawPanelTipsen.SportEventsWrapper', SportEventsWrapper);

 })(window);